module.exports = __webpack_public_path__ + "static/media/badge_level_4_3.a2871bdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_4_3.png
// module id = 516
// module chunks = 0